import { RodzajRaportu } from "./rodzajRaportu";

export class PobierzDaneDoGenerowaniaRaportuModel {
    idProjektu: string;
    idLokalizacji: string;
    rodzajRaportu: RodzajRaportu;
    idPomieszczen: Array<string> = new Array();
}